import { Env, getEnv } from "helpers/env";

// These are Firebase *client* API keys, which are not secret by design
// (Firebase security is enforced server-side / via security rules), so it's
// safe to keep them alongside the rest of the client config here.
type RecordingFirebaseConfig = {
  apiKey: string;
  projectId: string;
};

const RECORDING_FIREBASE_CONFIG_STAGING: RecordingFirebaseConfig = {
  apiKey: "AIzaSyByurx7ATo2VMofeZ3JnnIy1qJD18pBdAc",
  projectId: "fir-chat-poc-17ac7",
};

const RECORDING_FIREBASE_CONFIG_PRODUCTION: RecordingFirebaseConfig = {
  apiKey: "AIzaSyBy-ef9kIxC4omSHrz6p7IvMCnuku8dAZA",
  projectId: "sr-sales-chat-center-prod",
};

const getRecordingFirebaseConfig = (
  env: Env = getEnv()
): RecordingFirebaseConfig => {
  return env === "production"
    ? RECORDING_FIREBASE_CONFIG_PRODUCTION
    : RECORDING_FIREBASE_CONFIG_STAGING;
};

const getCallableFunctionUrl = (
  functionName: string,
  env: Env = getEnv()
): string => {
  const { projectId } = getRecordingFirebaseConfig(env);
  return `https://us-central1-${projectId}.cloudfunctions.net/${functionName}`;
};

export { getCallableFunctionUrl, getRecordingFirebaseConfig };
export type { RecordingFirebaseConfig };
